import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:INVOICES";

export const createInvoiceAccount = (userId, data) => {
    LogService.trace(LOG_TAG, "createInvoiceAccount");

    const body = JSON.stringify(data);

    return RainbowServerFetch.post(`/api/rainbow/subscription/v1.0/developers/${userId}/accounts`, body)
    .then(response => {
        LogService.info(LOG_TAG, "createInvoiceAccount", "successfully to create an invoice account");
        return Promise.resolve(response);
    })
    .catch(error => {
        LogService.error(LOG_TAG, "createInvoiceAccount", "error", error);
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
    })
}

export const getInvoiceAccount = (userId) => {
    LogService.trace(LOG_TAG, "getInvoiceAccount");

    return RainbowServerFetch.get(`/api/rainbow/subscription/v1.0/developers/${userId}/accounts?format=full`)
    .then(response => {
        LogService.info(LOG_TAG, "getAccount", "successfully to get account");
        return Promise.resolve(response);
    })
    .catch(error => {
        LogService.error(LOG_TAG, "getAccount", "error", error);
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
    })
}

export const updateInvoiceAccount = (userId, data) => {
    LogService.trace(LOG_TAG, "updateInvoiceAccount");

    const body = JSON.stringify(data);

    return RainbowServerFetch.put(`/api/rainbow/subscription/v1.0/developers/${userId}/accounts?format=full`, body)
    .then(response => {
        LogService.info(LOG_TAG, "updateAccount", "successfully to update account");
        return Promise.resolve(response);
    })
    .catch(error => {
        LogService.error(LOG_TAG, "updateAccount", "error", error);
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
    })
}

export const getListOfInvoices = (userId) => {
    LogService.trace(LOG_TAG, "getListOfInvoices");

    return RainbowServerFetch.get(`/api/rainbow/subscription/v1.0/developers/${userId}/invoices?format=full`)
    .then(response => {
        LogService.info(LOG_TAG, "getListOfInvoices", "successfully to get list of invoices");
        return Promise.resolve(response);
    })
    .catch(error => {
        LogService.error(LOG_TAG, "getListOfInvoices", "error", error);
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
    })
}

export const downloadInvoice = (userId, fileId) => {
    LogService.trace(LOG_TAG, "downloadInvoice");

    return RainbowServerFetch.get(`/api/rainbow/subscription/v1.0/developers/${userId}/invoices/files/${fileId}`)
    .then(response => {
        LogService.info(LOG_TAG, "downloadInvoice", "successfully received invoices");
        return Promise.resolve(response);
    })
    .catch(error => {
        LogService.error(LOG_TAG, "downloadInvoice", "error", error);
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
    })
}